import { useTranslations } from 'next-intl';

import { type ListingType } from '@/features/listing/types/listing-types';
import { type GeoPage } from '@/features/place/types/geo-page-types';
import urlToPlaceName from '@/features/place/utils/url-to-place-name';
import { Link } from '@/i18n/routing';

import styles from './listings-seo-links.module.scss';

interface ListingsSeoLinksProps {
  geoPage: GeoPage;
  listingType: ListingType;
}

export default function ListingsSeoLinks(props: ListingsSeoLinksProps) {
  const {
    geoPage,
    listingType,
  } = props;

  const translationsSeo = useTranslations('seo.links');

  return geoPage.cityLinks && (
    <div className={styles.listingsSeoLinks}>
      <h3 className={styles.listingsSeoLinks_title}>
        {`${urlToPlaceName(geoPage.locationToken)} ${translationsSeo(`title.${listingType}`)}`}
      </h3>

      <div className={styles.listingsSeoLinks_wrapper}>
        <div className={styles.listingsSeoLinks_container}>
          <h4 className={styles.listingsSeoLinks_areaTitle}>
            {`${translationsSeo('areas-in')} ${urlToPlaceName(geoPage.areaToken)}:`}
          </h4>

          <ul className={styles.listingsSeoLinks_list}>
            {geoPage.cityLinks.map(({
              locationToken,
              path,
            }) => {
              const decodedPlaceName = urlToPlaceName(locationToken);

              return (
                <li key={path} className={styles.listingsSeoLinks_item}>
                  <Link prefetch={false} href={path}>
                    {decodedPlaceName}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {geoPage.neighborhoodLinks && geoPage.cityToken && (
          <div className={styles.listingsSeoLinks_container}>
            <h4 className={styles.listingsSeoLinks_areaTitle}>
              {`${translationsSeo('neighborhood-in')} ${urlToPlaceName(geoPage.cityToken)}:`}
            </h4>

            <ul className={styles.listingsSeoLinks_list}>
              {geoPage.neighborhoodLinks.map(({
                locationToken,
                path,
              }) => {
                const decodedPlaceName = urlToPlaceName(locationToken);

                return (
                  <li key={path} className={styles.listingsSeoLinks_item}>
                    <Link href={path}>
                      {decodedPlaceName}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
